import { gql } from '@apollo/client'

export const ADD_NOTE_TO_ACTIONS = gql`
  mutation AddNoteToActions($data: AddNoteToActionsInput!) {
    addNoteToActions(data: $data) {
      id
      note
      createdTime
      action {
        id
        store {
          id
          location {
            id
            name
          }
        }
      }
    }
  }
`
